<template>
  <div>
    <DescriptionsItem
      v-if="!isTextType && !isArrayType"
      :span="24"
      :labelWidth="labelWidth"
      :labelAlign="labelAlign"
      :label="$t('Product.specsLength')"
    >
      {{ info.specs.length | format }}
    </DescriptionsItem>
    <!-- int、float、double -->
    <template v-if="isNumberType">
      <DescriptionsItem
        :span="24"
        :labelWidth="labelWidth"
        :labelAlign="labelAlign"
        :label="$t('Product.dataRange')"
      >
        {{ info.specs.min | format }} ~ {{ info.specs.max | format }}
      </DescriptionsItem>
      <DescriptionsItem
        :span="24"
        :labelWidth="labelWidth"
        :labelAlign="labelAlign"
        :label="$t('Common.unit2')"
      >
        {{ info.specs.unitName | format }}
      </DescriptionsItem>
      <DescriptionsItem
        :span="24"
        :labelWidth="labelWidth"
        :labelAlign="labelAlign"
        :label="$t('Product.hasSigned')"
      >
        {{ info.specs.signed | formatSigned }}
      </DescriptionsItem>
    </template>
    <!-- text -->
    <template v-if="isTextType">
      <DescriptionsItem
        :span="24"
        :labelWidth="labelWidth"
        :labelAlign="labelAlign"
        :label="$t('Product.dataLength')"
      >
        {{ info.specs.length | format }} {{ $t('Product.bite') }}
      </DescriptionsItem>
    </template>
    <!-- bool -->
    <template v-if="isBoolType">
      <DescriptionsItem
        :span="24"
        :labelWidth="labelWidth"
        :labelAlign="labelAlign"
        :label="$t('Product.bool')"
      >
        <p class="enum-item"><span class="desc">false:</span> {{ info.specs.enumDesc[0] }}</p>
        <p class="enum-item"><span class="desc">true:</span> {{ info.specs.enumDesc[1] }}</p>
      </DescriptionsItem>
    </template>
    <!-- enum -->
    <template v-if="isEnumType">
      <DescriptionsItem
        :span="24"
        :labelWidth="labelWidth"
        :labelAlign="labelAlign"
        :label="$t('Product.enumDesc')"
      >
        <p class="enum-item" v-for="(item, index) in info.specs.enumDescArr" :key="index">
          {{ item.key }}
          <span class="desc">({{ item.value }})</span>
        </p>
      </DescriptionsItem>
    </template>
    <!-- array -->
    <template v-if="isArrayType">
      <DescriptionsItem
        :span="24"
        :labelWidth="labelWidth"
        :labelAlign="labelAlign"
        :label="$t('Product.elementType')"
      >
        {{ info.specs.type | format }}
      </DescriptionsItem>
      <DescriptionsItem
        :span="24"
        :labelWidth="labelWidth"
        :labelAlign="labelAlign"
        :label="$t('Product.eleNum')"
      >
        {{ info.specs.length | format }}
      </DescriptionsItem>
      <JsonParamsDetailItem
        v-if="info.specs.type === 'struct'"
        :label="$t('Product.JSONObject')"
        :labelWidth="labelWidth"
        :labelAlign="labelAlign"
        :jsonArr="info.specs.item"
        :isFirstLevel="!isFirstLevel"
      ></JsonParamsDetailItem>
    </template>
    <!-- struct -->
    <template v-if="isStructType">
      <JsonParamsDetailItem
        :label="$t('Product.JSONObject')"
        :labelWidth="labelWidth"
        :labelAlign="labelAlign"
        :jsonArr="info.specs.item"
        :isFirstLevel="!isFirstLevel"
      ></JsonParamsDetailItem>
    </template>
  </div>
</template>

<script>
import DescriptionsItem from '@/components/Descriptions/DescriptionsItem'
import JsonParamsDetailItem from './JsonParamsDetailItem'

import { format, formatTime } from '@/utils/utils'
import { unitOptions } from './data'
export default {
  name: 'DataTypeDetailItem',
  props: {
    info: {
      type: Object
    },
    labelWidth: {
      type: String
    },
    labelAlign: {
      type: String
    },
    isFirstLevel: {
      type: Boolean,
      default: true
    }
  },
  components: {
    DescriptionsItem,
    JsonParamsDetailItem
  },
  computed: {
    isNumberType() {
      return (
        this.info.dataType === 'int' ||
        this.info.dataType === 'float' ||
        this.info.dataType === 'double'
      )
    },
    isTextType() {
      return this.info.dataType === 'text'
    },
    isEnumType() {
      return this.info.dataType === 'enum'
    },
    isBoolType() {
      return this.info.dataType === 'bool'
    },
    isStructType() {
      return this.info.dataType === 'struct'
    },
    isArrayType() {
      return this.info.dataType === 'array'
    }
  },
  filters: {
    format,
    formatTime,
    formatSigned(val) {
      if (val === true) {
        return this.$t('Product.hasSignedY')
      } else if (val === false) {
        return this.$t('Product.hasSignedN')
      } else {
        return '-'
      }
    }
  },
  watch: {
    'info.dataType': {
      handler(val) {
        if (val) {
          this.formatData()
        }
      },
      immediate: true
    }
  },
  methods: {
    formatData() {
      if (this.isEnumType && this.info.specs.enumDesc) {
        const enumDescArr = []
        for (const key in this.info.specs.enumDesc) {
          enumDescArr.push({
            key,
            value: this.info.specs.enumDesc[key]
          })
        }
        this.$set(this.info.specs, 'enumDescArr', enumDescArr)
      } else if (this.isNumberType) {
        const unit = unitOptions.find((item) => item.unit === this.info.specs.unit)
        this.$set(this.info.specs, 'unitName', unit.name)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.enum-item {
  font-size: 14px;
  color: #333333;
  margin-bottom: 16px;
  .desc {
    color: #888888;
  }
}
</style>
